"use client";

import { useEffect, useSyncExternalStore } from "react";
import { Moon, Sun } from "@app-foundation/icons/lucide";
import { appearanceEvent, appearanceKey, parseAppearance, setAppearance } from "./theme";

function subscribe(callback: () => void) {
  window.addEventListener(appearanceEvent, callback);
  return () => window.removeEventListener(appearanceEvent, callback);
}
function snapshot() { return parseAppearance(document.documentElement.dataset.appearance); }

export function AppearanceSync() {
  useEffect(() => {
    const mq = window.matchMedia("(prefers-color-scheme: dark)");
    const updateSystem = () => { if (snapshot() === "system") setAppearance("system", false); };
    const updateStorage = (event: StorageEvent) => { if (event.key === appearanceKey || event.key === null) setAppearance(parseAppearance(event.newValue), false); };
    mq.addEventListener("change", updateSystem);
    window.addEventListener("storage", updateStorage);
    // Reconcile system changes and legacy palette attributes after hydration or hot reload.
    setAppearance(snapshot(), false);
    return () => { mq.removeEventListener("change", updateSystem); window.removeEventListener("storage", updateStorage); };
  }, []);
  return null;
}

export function AppearanceControl() {
  const scheme = useSyncExternalStore(subscribe, () => document.documentElement.dataset.theme ?? "dark", () => "dark");
  const TriggerIcon = scheme === "light" ? Sun : Moon;
  const label = scheme === "light" ? "切换为夜间模式" : "切换为白天模式";
  return (
    <span className="appearance-control">
      <button type="button" aria-label={label} title={label} onClick={() => {
        setAppearance(document.documentElement.dataset.theme === "light" ? "dark" : "light");
      }}>
        <TriggerIcon size={19} aria-hidden="true" />
      </button>
    </span>
  );
}
